export enum MediaTypesEnum{
    MESSAGE = 'message',
    AUDIO = 'audio',
    VIDEO = 'video',
    IMAGE = 'image',
    PDF = 'pdf',
    ATTACHMENT = 'attachment'
}
